import { Cell, TableData } from 'utils/data'
import { isDistrict, isGroup, isRGD, isRegion } from 'utils/location'

export const getDynamicSubPath = (location: string, prefix: boolean = true) => {
    if (!isRGD(location)) {
        return ''
    }

    if (prefix) {
        if (isRegion(location)) {
            return `REGION/${location}`
        } else if (isGroup(location)) {
            return `GROUP/${location}`
        } else if (isDistrict(location)) {
            return `DISTRICT/${location}`
        }
    } else {
        return location
    }

    return ''
}

export const setFirstColumnInHeaders = (data: TableData, label: string) => {
    return data?.headings?.map((heading: Cell, index: number) =>
        index === 0 ? { ...heading, value: label } : { ...heading },
    )
}

export const addHyperLinkToFirstColumn = (
    data: TableData,
    pathname: string,
) => {
    return {
        ...data,
        rows: data.rows?.map((row: Cell[], index: number) => {
            const [firstCell, ...otherCells] = row
            const locationCell =
                index > 0
                    ? {
                          ...firstCell,
                          url:
                              pathname +
                              '?locationId=' +
                              (firstCell.value || ''),
                      }
                    : { ...firstCell }
            return [locationCell, ...otherCells.map((cell) => ({ ...cell }))]
        }),
    }
}

const emptyTable: TableData = {
    headings: [],
    rows: [],
}

export const transformLaggingData = (rawData: TableData) => {
    if (!rawData?.rows || rawData.rows.length === 0) {
        return emptyTable
    }

    const row = rawData.rows[0]
    if (!row) {
        return emptyTable
    }

    const headings = rawData.headings ?? []

    const teamYtdCount = row[1]
    const team8WkRate = row[2]
    const teamYtdRate = row[4]

    const guestYtdCount = row[6]
    const guestYtdRate = row[8]

    const teamParts = (headings[1]?.value ?? '').split(/(?<=Injury)\s+/)
    const guestParts = (headings[6]?.value ?? '').split(/(?<=Incident)\s+/)

    const teamHeader = (teamParts[0] ?? '').toLowerCase()
    const guestHeader = (guestParts[0] ?? '').trim().toLowerCase()

    const ytdCountLabel = (teamParts[1] ?? '').toLowerCase()
    const wk8RateLabel =
        (headings[2]?.value ?? '').split(/(?<=Injury)\s+/)[1]?.toLowerCase() ??
        ''
    const ytdRateLabel =
        (headings[4]?.value ?? '').split(/(?<=Injury)\s+/)[1]?.toLowerCase() ??
        ''

    return {
        headings: [
            { value: 'timeframe' },
            { value: teamHeader },
            { value: guestHeader },
        ],
        rows: [
            [
                { value: ytdCountLabel, color: '', raw: ytdCountLabel },
                teamYtdCount,
                guestYtdCount,
            ],
            [
                { value: wk8RateLabel, color: '', raw: wk8RateLabel },
                team8WkRate,
                { value: ' ', color: '', raw: '' },
            ],
            [
                { value: ytdRateLabel, color: '', raw: ytdRateLabel },
                teamYtdRate,
                guestYtdRate,
            ],
        ],
    }
}

export const transformTotalData = (rawData: TableData) => {
    if (!rawData?.rows || rawData.rows.length === 0) {
        return emptyTable
    }

    const row = rawData.rows[0]
    if (!row) {
        return emptyTable
    }

    const teamYtdCount = row[1]

    return {
        headings: [{ value: 'timeframe' }, { value: 'team' }],
        rows: [
            [{ value: 'ytd count', color: '', raw: 'ytd count' }, teamYtdCount],
        ],
    }
}

export const transformLeadingData = (rawData: TableData) => {
    if (!rawData?.rows || rawData.rows.length === 0) {
        return emptyTable
    }

    const row = rawData.rows[0]
    if (!row) {
        return emptyTable
    }

    const headings = rawData.headings ?? []

    return {
        headings: [{ value: 'indicator' }, { value: 'ytd' }],
        rows: headings.slice(1).map((heading: any, index: number) => {
            const label = (heading?.value ?? '').toLowerCase()
            return [{ value: label, color: '', raw: label }, row[index + 1]]
        }),
    }
}
